var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "viewport-info" }, [
      _c("p", [_vm._v("Breite: " + _vm._s(_vm.width) + "px")]),
      _c("p", [_vm._v("Höhe: " + _vm._s(_vm.height) + "px")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }